import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';
import NewsletterSubscribe from './NewsletterSubscribe/NewsletterSubscribe';
import NewsletterUnsubscribe from './NewsletterUnsubscribe/NewsletterUnsubscribe';
import Loader from 'components/Common/Loader/Loader';
import { useCustomer } from 'hooks/useCustomer';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

import styles from './NewsletterPage.module.scss';

export default function NewsletterPage(): JSX.Element {
  const { t } = useTranslation(['newsletterPage']);
  const [submitStatus, setSubmitStatus] = useState<boolean | undefined>(
    undefined
  );
  const { isLogged } = useCustomer();

  useGtmPageView(GTM_PAGE_OTHER, `Afibel - ${t('NEWSLETTER_SUB_META_TITLE')}`);

  if (isLogged || isLogged === null) {
    return (
      <>
        <RenderMetadata />
        <Loader />
      </>
    );
  }

  return (
    <div className={styles.container}>
      <RenderMetadata />
      <h1>{t('LABEL_TITLE')}</h1>
      {submitStatus && (
        <Alert severity="success" className={styles.alert}>
          {t('LABEL_YOUR_SUBSCRIPTION_SUCCEED')}
        </Alert>
      )}
      <NewsletterSubscribe setSubmitStatus={setSubmitStatus} />
      <NewsletterUnsubscribe />
    </div>
  );
}

function RenderMetadata(): JSX.Element {
  const { t } = useTranslation(['newsletterPage']);

  return (
    <Helmet>
      <title>
        {t('META_TITLE_TEMPLATE', {
          title: t('NEWSLETTER_SUB_META_TITLE'),
          ns: 'translation',
        })}
      </title>
      <meta name="description" content={t('NEWSLETTER_SUB_META_DESCRIPTION')} />
    </Helmet>
  );
}
